import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { makeImagePreviewable } from '../utils';

import Block from './Block';
import Image from './Image';
import VideoPlayerAWS from './VideoPlayerAWS';

const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const MediaDisplay = ({ content, imageDisplay }) => {
  const hasVideo = Boolean(
    content.video?.embed_url || content.amazon_video_path,
  );

  const image = makeImagePreviewable(content.image);
  const hasImage = Boolean(image?.localFile);
  let videoId = '';
  let videoSrc = content.amazon_video_path || '';
  let videoProvider = '';

  if (hasVideo) {
    if (content.amazon_video_path) {
      videoProvider = 'Amazon';
    } else if (content.video.provider_name === 'Vimeo') {
      videoProvider = 'Vimeo';
    } else {
      videoProvider = content.video.embed_url.includes('https://v.qq.com')
        ? 'QQ'
        : 'other';
    }

    switch (videoProvider) {
      case 'Vimeo':
        videoId = content.video.embed_url.replace('https://vimeo.com/', '');
        videoSrc = `https://player.vimeo.com/video/${videoId}?app_id=122963&dnt=1`;
        break;
      case 'QQ':
        // eslint-disable-next-line prefer-destructuring
        videoId = content.video.embed_url
          .replace('https://v.qq.com/x/page/', '')
          .split('.html')[0];
        videoSrc = `https://v.qq.com/txp/iframe/player.html?vid=${videoId}&tiny=0&auto=0`;
        break;
      case 'Amazon':
        break;
      default:
        videoSrc = content.video.embed_url;
        break;
    }
  }

  return (
    <>
      {hasVideo && (
        <>
          {videoProvider === 'Amazon' ? (
            <VideoPlayerAWS videoSource={videoSrc} />
          ) : (
            <VideoWrapper>
              <iframe
                style={{ width: '100%', height: '100%' }}
                src={videoSrc}
                title={content.video.title}
                frameBorder="0"
                marginWidth="0"
                marginHeight="0"
                scrolling="no"
                allowFullScreen
              />
            </VideoWrapper>
          )}
        </>
      )}

      {hasImage && (
        <Block display={imageDisplay}>
          <Image content={image} />
        </Block>
      )}
    </>
  );
};

MediaDisplay.defaultProps = {
  imageDisplay: { mobile: 'block', tablet: 'none' },
};

MediaDisplay.propTypes = {
  content: PropTypes.shape({
    video: PropTypes.shape({
      title: PropTypes.string,
      embed_url: PropTypes.string,
      provider_name: PropTypes.string,
    }),
    amazon_video_path: PropTypes.string,
    image: PropTypes.shape({
      alt: PropTypes.string,
      localFile: PropTypes.shape({
        extension: PropTypes.string,
        url: PropTypes.string,
        childImageSharp: PropTypes.shape({ fluid: PropTypes.shape({}) }),
      }),
    }),
  }).isRequired,
  imageDisplay: PropTypes.shape({}),
};

export default MediaDisplay;
